export default (
	webhook: string,
	data: Record<string, string>
): Promise<unknown> => {
	if (import.meta.client && process.env.NODE_ENV !== 'production') {
		console.warn('not submitted:', {
			method: 'POST',
			headers: {
				Accept: 'application/json',
			},
			body: JSON.stringify(data),
		});

		return Promise.resolve();
	}

	return $fetch(webhook, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
		},
		body: JSON.stringify(data),
	});
};
